/**
 * @generated SignedSource<<1e305c2ef987f767d09e00080e6f4365>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ContentSystemTaskKind = "add_events_to_calendar" | "calendar_connection" | "community_agreement" | "complete_profile" | "connect_slack" | "custom_profile_field" | "default_profile_fields" | "download_mobile_app" | "onboarding_complete" | "onboarding_module" | "onboarding_welcome" | "slack_connection" | "slack_invite" | "%future added value";
export type ContentType = "assignment" | "assignment_submission" | "attachment" | "comment" | "confirmation" | "custom" | "embed" | "module" | "occurrence" | "post" | "quiz" | "survey" | "text" | "video" | "%future added value";
export type ContentUsageEntity = "collection" | "content" | "content_usage_confirmation" | "curriculum" | "dashboard_block_content" | "member_onboarding" | "organization" | "product_app" | "%future added value";
export type ContentUsageSubmissionMethod = "mark_as_complete" | "submission" | "%future added value";
export type ContentUsageSubmissionVisibility = "cohort" | "member_group" | "private" | "%future added value";
export type ProductAppKind = "chat_channel" | "collection" | "content" | "curriculum" | "dashboard" | "events" | "group_directory" | "link" | "member_directory" | "members" | "nav_folder" | "organization_events" | "organization_members" | "posts" | "product_link" | "resources" | "slack" | "%future added value";
export type WebFormQuestionType = "link" | "multiple_select" | "ranking" | "rating" | "single_select" | "written_answer" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type InlineContentDrawerTemplateFragment$data = {
  readonly confirmationModalContent: {
    readonly ctaText: string | null;
    readonly id: string;
    readonly name: string | null;
    readonly richEditorDescriptionContent: string | null;
  } | null;
  readonly content: {
    readonly attachments: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly mediaUrl: string | null;
          readonly name: string;
        };
      }>;
    };
    readonly contentLabelId: string | null;
    readonly coverPhoto: string | null;
    readonly coverVideo: string | null;
    readonly coverVideoAsset: {
      readonly id: string;
    } | null;
    readonly coverVideoDurationSeconds: number | null;
    readonly id: string;
    readonly label: string;
    readonly name: string | null;
    readonly richEditorDescriptionContent: string | null;
    readonly showCoverPlayIcon: boolean;
    readonly systemTaskKind: ContentSystemTaskKind | null;
    readonly thumbnailUrl: string | null;
    readonly timeEstimateMinutes: number | null;
    readonly type: ContentType;
    readonly usages: {
      readonly totalCount: number;
    };
    readonly webForm: {
      readonly currentRevision: {
        readonly id: string;
        readonly questions: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly answerKey: {
                readonly correctIds: ReadonlyArray<string>;
                readonly feedback: string | null;
              } | null;
              readonly id: string;
              readonly isRequired: boolean;
              readonly options: ReadonlyArray<{
                readonly id: string;
                readonly label: string;
              }> | null;
              readonly ordering: number;
              readonly richEditorBody: string;
              readonly type: WebFormQuestionType;
            };
          }>;
        };
        readonly webFormId: string;
      };
      readonly id: string;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"BookmarkButtonContentFragment" | "DiscoEditorMentionsFragment" | "InlineContentAttachmentsSectionFragment" | "InlineContentDescriptionSectionFragment" | "InlineContentHeroAndProperties_ContentFragment" | "InlineContentHeroSectionFragment">;
  };
  readonly contentDashboardBlock: {
    readonly id: string;
  } | null;
  readonly dueAt: string | null;
  readonly entity: ContentUsageEntity;
  readonly entityId: string;
  readonly hasPrerequisites: boolean;
  readonly id: string;
  readonly isLocked: boolean;
  readonly module: {
    readonly name: string | null;
    readonly usages: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"InlineContentDrawerTemplate_ModuleContentUsageFragment">;
        };
      }>;
    };
  } | null;
  readonly ordering: number | null;
  readonly passPercentage: number | null;
  readonly prerequisites: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
      };
    }>;
  } | null;
  readonly product: {
    readonly adminCanLearnMode: boolean;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"LearnModeSwitchFragment">;
  } | null;
  readonly productApp: {
    readonly id: string;
    readonly kind: ProductAppKind;
  } | null;
  readonly requireScormCompletion: boolean;
  readonly showComments: boolean | null;
  readonly submissionFormat: {
    readonly file: {
      readonly enabled: boolean;
      readonly required: boolean;
    };
    readonly link: {
      readonly enabled: boolean;
      readonly required: boolean;
    };
    readonly text: {
      readonly enabled: boolean;
      readonly required: boolean;
    };
  } | null;
  readonly submissionMethod: ContentUsageSubmissionMethod | null;
  readonly submissionVisibility: ContentUsageSubmissionVisibility | null;
  readonly " $fragmentSpreads": FragmentRefs<"BookmarkButtonContentUsageFragment" | "ConnectSlackCurriculumItemBannerFragment" | "ContentFooterSection_ContentUsageFragment" | "ContentUsageAssignmentSubmitBannerFragment" | "InlineContentDrawerFooterFragment" | "InlineContentDrawerHeaderOverflowFragment" | "InlineContentDrawerTitleFormFragment" | "QuizEditorBanner_ContentUsageFragment" | "QuizSubmissionEditorContentUsageFragment" | "ShareContentUsageButtonFragment" | "usePermissionsFragment" | "useTrackContentViewFragment">;
  readonly " $fragmentType": "InlineContentDrawerTemplateFragment";
};
export type InlineContentDrawerTemplateFragment$key = {
  readonly " $data"?: InlineContentDrawerTemplateFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"InlineContentDrawerTemplateFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ordering",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "enabled",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "required",
    "storageKey": null
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "richEditorDescriptionContent",
  "storageKey": null
},
v7 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InlineContentDrawerTemplateFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLocked",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPrerequisites",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entity",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dueAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "submissionMethod",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "submissionVisibility",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AssignmentSubmissionFormat",
      "kind": "LinkedField",
      "name": "submissionFormat",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AssignmentSubmissionFormatSettings",
          "kind": "LinkedField",
          "name": "text",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AssignmentSubmissionFormatSettings",
          "kind": "LinkedField",
          "name": "file",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AssignmentSubmissionFormatSettings",
          "kind": "LinkedField",
          "name": "link",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showComments",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "passPercentage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "requireScormCompletion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "content",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v3/*: any*/),
        (v4/*: any*/),
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "systemTaskKind",
          "storageKey": null
        },
        (v6/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentAttachmentNodeConnection",
          "kind": "LinkedField",
          "name": "attachments",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ContentAttachmentNodeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ContentAttachment",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v3/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "mediaUrl",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "thumbnailUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "coverPhoto",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "coverVideo",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timeEstimateMinutes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Asset",
          "kind": "LinkedField",
          "name": "coverVideoAsset",
          "plural": false,
          "selections": (v7/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "coverVideoDurationSeconds",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showCoverPlayIcon",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentUsageNodeConnection",
          "kind": "LinkedField",
          "name": "usages",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contentLabelId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "WebForm",
          "kind": "LinkedField",
          "name": "webForm",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "WebFormRevision",
              "kind": "LinkedField",
              "name": "currentRevision",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "webFormId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "WebFormQuestionNodeConnection",
                  "kind": "LinkedField",
                  "name": "questions",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "WebFormQuestionNodeEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "WebFormQuestion",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            (v4/*: any*/),
                            (v1/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "richEditorBody",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "isRequired",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "WebFormQuestionOption",
                              "kind": "LinkedField",
                              "name": "options",
                              "plural": true,
                              "selections": [
                                (v0/*: any*/),
                                (v5/*: any*/)
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "WebFormQuestionAnswerKey",
                              "kind": "LinkedField",
                              "name": "answerKey",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "correctIds",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "feedback",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "InlineContentHeroSectionFragment"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "InlineContentAttachmentsSectionFragment"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "InlineContentDescriptionSectionFragment"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "InlineContentHeroAndProperties_ContentFragment"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BookmarkButtonContentFragment"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "DiscoEditorMentionsFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentUsageNodeConnection",
      "kind": "LinkedField",
      "name": "prerequisites",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentUsageNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ContentUsage",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v7/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "product",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "adminCanLearnMode",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "LearnModeSwitchFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductApp",
      "kind": "LinkedField",
      "name": "productApp",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "kind",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "module",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentUsageNodeConnection",
          "kind": "LinkedField",
          "name": "usages",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ContentUsageNodeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ContentUsage",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "InlineContentDrawerTemplate_ModuleContentUsageFragment"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentDashboardBlock",
      "kind": "LinkedField",
      "name": "contentDashboardBlock",
      "plural": false,
      "selections": (v7/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "confirmationModalContent",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v3/*: any*/),
        (v6/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ctaText",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "QuizSubmissionEditorContentUsageFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InlineContentDrawerTitleFormFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InlineContentDrawerHeaderOverflowFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContentFooterSection_ContentUsageFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InlineContentDrawerFooterFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePermissionsFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useTrackContentViewFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "QuizEditorBanner_ContentUsageFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContentUsageAssignmentSubmitBannerFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ConnectSlackCurriculumItemBannerFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookmarkButtonContentUsageFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShareContentUsageButtonFragment"
    }
  ],
  "type": "ContentUsage",
  "abstractKey": null
};
})();

(node as any).hash = "07a3ef6491701ff4374441c39622d7e7";

export default node;
